<template>
  <b-card-code
    title=""
    no-body
  >
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-link :to="{ path: '/data-user/add' }">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="ml-1 mb-1"
              variant="outline-primary"
            >
              <feather-icon icon="PlusIcon" /> Create
            </b-button>
          </b-link>
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              variant="primary"
              @click="exportExcel"
            >
              <span class="text-nowrap">Export Excel</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="d-flex justify-content-between flex-wrap">
      <!-- sorting  -->
      <b-form-group
        label="Sort"
        label-size="sm"
        label-align-sm="left"
        label-cols-sm="3"
        label-for="sortBySelect"
        class="ml-1"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
          >
            <template #first>
              <option value="">
                none
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
          >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>

      <!-- filter -->
      <b-form-group
        label="Filter"
        label-cols-sm="2"
        label-align-sm="left"
        label-size="sm"
        label-for="filterInput"
        class="mr-1"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table
      striped
      hover
      responsive
      class="position-relative"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
    >
      <template #cell(created_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(updated_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(deleted_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(last_ip_address_access)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(last_phone_access)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(photo)="data">
        <b-avatar :src="data.value" />
      </template>
      <template #cell(action)="row">
        <b-button
          v-b-modal.modal-center
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          :to="{ path: '/data-user/detail/'+ row.item.id}"
          variant="outline-primary"
          class="btn-icon"
        >
          <!-- <feather-icon icon="CheckCircleIcon"/> -->
          Edit
        </b-button>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
          @input="filterData"
        />
      </b-form-group>
      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @input="filterData"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BRow, BCol, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import XLSX from 'xlsx'
import store from '@/store/index'

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({ name: XLSX.utils.encode_col(i), key: i }))
const _SheetJSFT = ['xlsx', 'xlsb', 'xlsm', 'xls', 'xml', 'csv', 'txt', 'ods', 'fods', 'uos', 'sylk', 'dif', 'dbf', 'prn', 'qpw', '123', 'wb*', 'wq*', 'html', 'htm'].map(x => `.${x}`).join(',')
export default {
  components: {
    XLSX, moment, BCardCode, BTable, BRow, BCol, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent,
  },
  data() {
    const startDate = new Date()
    const endDate = new Date()
    return {
      SheetJSFT: _SheetJSFT,
      dateRange: { startDate, endDate },
      dir: false,
      currentPage: 1,
      sortBy: '',
      perPage: 20,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        AC: 'Aktif Belum Dibayar', WC: 'Menunggu Konfirmasi', DC: 'Tolak Konsultasi', SC: 'Aktif Sudah Dibayar', EC: 'Pembayaran Expired', LS: 'Sedang Layanan Hukum', ED: 'Transaksi Selesai', SH: 'Terjadwal',
      },
      {
        AC: 'light-primary', WC: 'light-success', DC: 'light-danger', EC: 'light-warning', SC: 'light-info', LS: 'light-info', ED: 'light-info', SH: 'light-info',
      }],
      payment: [{
        XD: 'Xendit', JH: 'Universal IOT', MT: 'Midtrans',
      },
      {
        XD: 'light-primary', JH: 'light-primary', MT: 'light-primary',
      }],
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.user.totalRows,
      fields: state => state.user.fields,
      items: state => state.user.items,
      pageOptions: state => state.user.pageOptions,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
    mapFilter() {
      return {
        page: this.currentPage,
        limit: this.perPage,
        status: 'AC',
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    this.filterData()
  },
  methods: {
    formatDates(value) {
      console.log(value)
      var dateFormat = dateFormat || 'DD-MM-YYYY HH:mm:ss'
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY HH:mm:ss')
      }
    },
    filterData() {
      this.$store.dispatch('user/getAll', this.mapFilter)
    },
    moment(date) {
      return moment(date)
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('user/remove', id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('user/getAll')
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                } else {
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                }
              },
              error => {
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          }
        })
    },
    exportExcel(evt) {
      const jsons = []
      for (let x = 0; x < this.items.length; x++) {
        jsons[x] = {
          created_at: this.items[x].created_at ? moment(String(this.items[x].created_at)).format('DD-MM-YYYY HH:mm:ss') : '-',
          deleted_at: this.items[x].deleted_at ? moment(String(this.items[x].deleted_at)).format('DD-MM-YYYY HH:mm:ss') : '-',
          email: this.items[x].email,
          fcm_token: this.items[x].fcm_token,
          firebase_id: this.items[x].firebase_id,
          id: this.items[x].id,
          is_choose_profession: this.items[x].is_choose_profession,
          is_email_verified: this.items[x].is_email_verified,
          name: this.items[x].name,
          phone: this.items[x].phone,
          photo: this.items[x].photo,
          status: this.items[x].status,
          updated_at: this.items[x].updated_at ? moment(String(this.items[x].updated_at)).format('DD-MM-YYYY HH:mm:ss') : '-',
          user_type: this.items[x].user_type,
        }
      }
      const data_json = XLSX.utils.json_to_sheet(jsons)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data_json, 'data')
      XLSX.writeFile(wb, `user_${moment(this.dateRange.startDate.toISOString()).format('DD-MM-YYYY')}_${moment(this.dateRange.endDate.toISOString()).format('DD-MM-YYYY')}.xlsx`)
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
  },
  directives: {
    Ripple,
  },
}
</script>
